<script>
  import SubHeader from "../components/SubHeader.svelte";

  let subHeader = {
      bg_pc: '/images/sub_coffee.png',
      bg_mo: '/images/sub_coffee_m.png',
      title: '커피 스토리',
      dsc: '최상급 원두를 철저한 관리에서 로스팅합니다.'
    }
</script>

<SubHeader { ...subHeader } />

<section class="coffee">
    <div class="coffee__rosting">
      <div class="coffee__header header">
        <p class="header__text text">
          커피멘토의 원두는 HACCP 및 ISO 2200 기준 하에 로스팅하고 관리하고 있습니다.<br/>
          원재료 100% 샘플링 검사를 통해 생두를 검증합니다.<br/>
          그리고 로스팅 후에도 색도측정장비를 활용하고<span class="_newline" />
          국제 커피 감별사가 관능 평가를 진행해<span class="_newline" />
          객관적 품질 관리를 하고 있어<br/>
          최상급 원두를 최상의 관리하에 로스팅하고 있습니다.
        </p>
      </div>
    </div>

    <div class="coffee__premium">
      <div class="coffee__header header">
        <h1 class="header__heading heading heading_level_1">레종 프리미엄</h1>
        <p class="header__text text">
            브라질, 콜롬비아 원두를 블랜딩하여 진한 커피의 풍미와 달콤한 캐러멜 향미를 느낄 수 있는 커피입니다.<br/>
            갓 볶아 신선한 아몬드의 고소한 향과 실키한 바디감이 어우려져 기분 좋은 여운으로 남습니다.
        </p>
      </div>

      <p class="coffee__origin text">
          ORIGIN : Brazil, Colombia<br/>
          ROSTING GRADE : Full-City
      </p>

      <div class="coffee__origin-image"><img class="coffee__origin-img" src="/images/coffee_origin_graph.png" alt="coffee"/></div>
    </div>
</section>
